/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wpm: NonNullable<unknown> }} Event_Metrics_Wpm_TitleInputs */



/**
* | output |
* | --- |
* | "{wpm} Words Per Minute" |
*
* @param {Event_Metrics_Wpm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_metrics_wpm_title = /** @type {((inputs: Event_Metrics_Wpm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Metrics_Wpm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.wpm} Mots par minute`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.wpm} Wörter pro Minute`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.wpm} Parole al minuto`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.wpm} слов в минуту`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.wpm} Palabras por minuto`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.wpm} 每分钟字数`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.wpm} 1分あたりの単語数`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.wpm} शब्द प्रति मिनट`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.wpm} Palavras por minuto`)
	return /** @type {LocalizedString} */ (`${i?.wpm} Words Per Minute`)
});